<template>
  <div class="explain">
    <span>登录/注册即视为您已阅读并同意易隆创</span>
    <span class="agreement" @click="goServe">服务条款</span>
    <span>和</span>
    <span class="agreement" @click="goPolicy">隐私政策</span>
  </div>
</template>

<script>
export default {
  methods: {
    goServe() {
      window.open(this.$router.resolve({ path: "/servePolicy/serve" }).href, "_blank");
    },
    goPolicy() {
      window.open(this.$router.resolve({ path: "/servePolicy/policy" }).href, "_blank");
    },
  }
}
</script>

<style scoped lang="less">
.explain {
  font-size: 14px;
  color: #666666;
  .agreement {
    padding: 0 2px;
    color: @primary-color;
    cursor: pointer;
  }
}
</style>
